(function($){
	$(document).ready(function(){
		$( '.site-header' ).after( '<div class="nav-spacer"></div>' );

		var sizeNavSpacer = function(){
			if ( $( 'body' ).hasClass( 'floating-header-layout' ) ) {
				$( '.nav-spacer' ).css( { 'height' : '' } );
			} else {
				var navbarHeight =  $( '.site-header' ).outerHeight();
				$( '.nav-spacer' ).css( { 'height' : navbarHeight } );
			}
			$( '.site-header' ).addClass( 'fixed' );
		}
		sizeNavSpacer();

		$( window ).on( 'resize orientationchange', sizeNavSpacer );

		$( window ).on( 'scroll', function(){
			var st = $(this).scrollTop();
			if ( st > 10 ) {
				$( '.site-header' ).addClass( 'stuck' );
			} else {
				$( '.site-header' ).removeClass( 'stuck' );
			}
		} );
	})
})(jQuery)